import React from 'react';
import styled from 'styled-components';
// Removed social icons; no longer used

const FooterSection = styled.footer`
  background: #1a1a1a;
  padding: 3rem 2rem 2rem;
  border-top: 1px solid #2d3748;
  
  @media (max-width: 768px) {
    padding: 2rem 1rem 1.5rem;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 3rem;
  margin-bottom: 3rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: 2fr 1fr 1fr;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
`;

const BrandSection = styled.div``;

const Logo = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 1rem;
  
  svg {
    height: 40px;
    width: auto;
  }
`;

const BrandDescription = styled.p`
  color: #9ca3af;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    max-width: 400px;
    margin: 0 auto 1.5rem;
  }
`;

// Removed SocialLinks and SocialLink styled components

// Removed FooterColumn, ColumnTitle, FooterLinks, FooterLink styled components

const FooterBottom = styled.div`
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  
  @media (max-width: 768px) {
    justify-content: center;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: #9ca3af;
  font-size: 0.9rem;
`;

const LegalLinks = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    gap: 1rem;
    justify-content: center;
  }
  
  a {
    color: #9ca3af;
    font-size: 0.9rem;
    transition: color 0.3s ease;
    
    &:hover {
      color: #0891b2;
    }
  }
`;

const LighthouseLogo = () => (
  <svg viewBox="0 0 200 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Lighthouse with integrated waves */}
    <g>
      {/* Lighthouse structure */}
      <path d="M25 8 L22 20 L28 20 Z" fill="#0891b2"/>
      <rect x="22" y="20" width="6" height="20" fill="#0891b2"/>
      
      {/* Light beam as waves */}
      <path d="M30 15 Q40 12 50 15 T70 15" stroke="#06b6d4" strokeWidth="2" fill="none" opacity="0.8"/>
      <path d="M30 18 Q40 15 50 18 T70 18" stroke="#0891b2" strokeWidth="2" fill="none" opacity="0.6"/>
      <path d="M30 21 Q40 18 50 21 T70 21" stroke="#0e7490" strokeWidth="2" fill="none" opacity="0.4"/>
      
      {/* Base */}
      <path d="M20 40 L30 40 L32 45 L18 45 Z" fill="#164e63"/>
      
      {/* Light at top */}
      <circle cx="25" cy="8" r="2" fill="#fbbf24"/>
      <circle cx="25" cy="8" r="4" fill="#fbbf24" opacity="0.3"/>
    </g>
    
    {/* Text */}
    <text x="80" y="32" fontFamily="Arial, sans-serif" fontSize="28" fontWeight="700" fill="#ffffff">Faroflow</text>
  </svg>
);

const Footer = () => {
  return (
    <FooterSection>
      <Container>
        <FooterContent>
          <BrandSection>
            <Logo>
              <LighthouseLogo />
            </Logo>
            <BrandDescription>
              Guiding online casinos to exceptional player experiences through 
              intelligent AI-powered customer conversations.
            </BrandDescription>
          </BrandSection>

        </FooterContent>

        <FooterBottom>
          <Copyright>
            © 2026 Faroflow AI Ltd. All rights reserved. Built with ❤️ for the iGaming industry.
          </Copyright>
          <LegalLinks>
            <a href="/legal">Legal</a>
            <a href="/legal/privacy-policy.html">Privacy Policy</a>
            <a href="/legal/customer-terms.html">Terms of Service</a>
          </LegalLinks>
        </FooterBottom>
      </Container>
    </FooterSection>
  );
};

export default Footer; 